// extracted by mini-css-extract-plugin
module.exports = {"content":"Item_content__Ld8pz","title":"Item_title__JOXlq","label":"Item_label__BWKbp","file":"Item_file__M_rVo"};